/**
 * News data - separated from component logic
 * In React: This would come from an API, context, or props
 */
export const newsHeadlines = [
    "Jeglertz Takes Charge at Man City",
    "Goodison Named Permanent Everton Women Home",
    "WSL Expands to 14 Teams",
    "Sophie Ingle Departs Chelsea",
    "Summer Exhibition Matches",
    "Barcelona and Arsenal Set for UEFA Women's Champions League Final",
    "New Record Attendance at Wembley",
    "Women's World Cup Qualifiers Begin",
    "Rising Star Signs Professional Contract",
    "Championship Playoff Final Preview",
    "International Break Highlights",
    "Youth Development Program Launches",
    "Transfer Window Roundup",
    "Manager of the Month Announced",
    "Stadium Expansion Plans Revealed",
    "Community Outreach Initiative",
    "End of Season Awards Ceremony",
    "Pre-Season Training Begins",
    "New Sponsorship Deal Signed",
    "International Friendly Results",
    "League Cup Quarterfinals",
    "Player of the Week Nominees",
    "Injury Update Report",
    "Youth Academy Success Stories",
    "Fan Engagement Campaign",
    "Matchday Experience Improvements",
    "Women's Football Growth Statistics",
    "Coaching Staff Additions",
    "Season Ticket Sales Record",
    "Community Match Day",
    "International Call-Ups",
    "Training Ground Upgrade",
    "Partnership Announcement",
    "Match Preview: Derby Day",
    "Post-Match Analysis",
    "Fan Zone Activities",
    "Merchandise Launch",
    "Social Media Milestone",
    "Behind the Scenes Feature",
    "Next Generation Talent",
    "Match Highlights Available",
    "Press Conference Summary",
    "Team News Update",
    "Tactical Analysis",
    "Player Interview",
    "Match Report",
    "League Standings Update",
    "Upcoming Fixtures",
    "Historical Match Review",
    "Fan Poll Results",
    "Matchday Guide"
];

export const countries = ['UK', 'USA', 'FR', 'DE', 'ES', 'IT', 'BR', 'CA', 'AU', 'NL', 'SE', 'NO', 'DK', 'FI', 'PL', 'PT', 'BE'];

export const cardGradients = [
    'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
    'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
    'linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)',
    'linear-gradient(135deg, #fa709a 0%, #fee140 100%)',
    'linear-gradient(135deg, #30cfd0 0%, #330867 100%)',
    'linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)',
    'linear-gradient(135deg, #ff9a9e 0%, #fecfef 100%)'
];

